import { Box, Container, Popover, PopoverContent, PopoverTrigger, Table, Tbody, Td, Text, Th, Thead, Tr } from '@chakra-ui/react'
import NavbarOpen from '../NavLinks/NavbarOpen'
import ReactLinkify from 'react-linkify'
import { useCallback, useEffect, useState } from 'react'
import { getCompanyData } from '../../Api/dashboard'
import { DateTime } from 'luxon'
import { color } from 'framer-motion'

const BG_COLORS = ['#9AE095', '#DC043B', '#DC043B']
const COLORS = ['#000000', '#FFFFFF', '#FFFFFF']

// const tableHeadings = [{
//   id: 'name',
//   label: 'Name',
//   type: 'text',
//   width: 190
// }, {
//   id: 'website',
//   label: 'Website',
//   type: 'text',
//   width: 150
// }, {
//   id: 'last_interaction',
//   label: 'Last Interaction',
//   type: 'expand',
//   maxWidth: 300,
// }, {
//   id: 'linkedin_connection_status',
//   label: 'Linkedin - Connnection Status',
//   type: 'multi',
//   maxWidth: 300,
//   options: [{
//     id: 'not_sent',
//     label: 'No connection request sent',
//     color: '#000000',
//     backgroundColor: '#E5E9F0',
//   }, {
//     id: 'received',
//     label: 'Connection request received',
//     color: '#FFFFFF',
//     backgroundColor: '#DC043B',
//   }, {
//     id: 'accepted',
//     label: 'Connection request accepted',
//     color: '#000000',
//     backgroundColor: '#9AE095',
//   }]
// }, {
//   id: 'linkedin_message_status',
//   label: 'Linkedin - Message Status',
//   type: 'multi',
//   maxWidth: 300,
//   options: [{
//     id: 'not_sent',
//     label: 'No message sent',
//     color: '#000000',
//     backgroundColor: '#E5E9F0',
//   }, {
//     id: 'received',
//     label: 'Message received',
//     color: '#FFFFFF',
//     backgroundColor: '#DC043B',
//   }, {
//     id: 'responded',
//     label: 'Message responded',
//     color: '#000000',
//     backgroundColor: '#9AE095',
//   }]
// }, {
//   id: 'assignee',
//   label: 'Assignee',
//   type: 'multi',
//   maxWidth: 300,
//   options: [{
//     id: 'startup',
//     label: 'Startup',
//     color: '#000000',
//     backgroundColor: '#FFB68E',
//   }, {
//     id: 'vc',
//     label: 'VC',
//     color: '#000000',
//     backgroundColor: '#9AE095',
//   }]
// }, {
//   id: 'meetings',
//   label: 'Meetings',
//   type: 'expand',
//   maxWidth: 300,
// }, {
//   id: 'people_interacted',
//   label: 'People Interacted',
//   type: 'multi',
//   options: [{
//     id: 'devyani',
//     label: 'Devyani',
//     color: '#000000',
//     backgroundColor: '#9AE095',
//   }, {
//     id: 'chinmay',
//     label: 'Chinmay',
//     backgroundColor: '#DC043B',
//     color: '#FFFFFF'
//   }, {
//     id: 'dhairya',
//     label: 'Dhairya',
//     backgroundColor: '#DC043B',
//     color: '#FFFFFF'
//   }]
// }, {
//   id: 'vc_pov',
//   label: 'VC POV',
//   type: 'expand',
//   maxWidth: 300,
// }, {
//   id: 'startup_status',
//   label: 'Startup Status',
//   type: 'multi',
//   maxWidth: 300,
//   options: [{
//     id: 'awaiting_acceptance',
//     label: 'Awaiting Linkedin connection acceptance',
//     color: '#000000',
//     backgroundColor: '#D1E2FF',
//   }, {
//     id: 'connection_accepted',
//     label: 'Linkedin connection accepted',
//     color: '#000000',
//     backgroundColor: '#C4ECFF',
//   }, {
//     id: 'awaiting_response',
//     label: 'Awaiting Linkedin message response',
//     color: '#000000',
//     backgroundColor: '#C1F5F0',
//   }, {
//     id: 'responded',
//     label: 'Linkedin message responded',
//     color: '#000000',
//     backgroundColor: '#CFF5D1',
//   }, {
//     id: 'first_meeting',
//     label: 'First meeting done',
//     color: '#000000',
//     backgroundColor: '#FFEAB6',
//   }, {
//     id: 'second_meeting',
//     label: 'Second meeting done',
//     color: '#000000',
//     backgroundColor: '#FFE0CC',
//   }, {
//     id: 'third_meeting',
//     label: 'Third meeting done',
//     color: '#000000',
//     backgroundColor: '#FFD4E0',
//   }]
// }]

// const data = [{
//   id: 'arrowhead',
//   data: {
//     name: 'Arrowhead Inc',
//     website: 'www.example.comwww.example.comwww.example.comwww.example.com',
//     last_interaction: '6th July 2023 - Chinmay Shah',
//     linkedin_connection_status: 'not_sent',
//     linkedin_message_status: 'not_sent',
//     assignee: 'vc',
//     meetings: 
// `1st June 2023 - Arrowhead <> VC Connect - https://app.arrowhead.team/transcripts-summaries/summary?eventId=28ercc8t8r0ibkkh4as58vjvbc&tab=HIGH&eventName=Tech%20Daily%20Standup;

// 1st June 2023 - Meeting name - https://app.arrowhead.team/transcripts-summaries/summary?eventId=28ercc8t8r0ibkkh4as58vjvbc&tab=HIGH&eventName=Tech%20Daily%20Standup;
    
//     `,
//     people_interacted: 'devyani;chinmay',
//     vc_pov: 
// `Chinmay Shah (6th June 2023): some comment Abrbrbrr;

// Devyani Gupta (6th June 2023): some comment B;

// Dhairya Shah (6th June 2023): some comment C;

// Chinmay Shah (6th June 2023): some comment A

// Chinmay Shah (6th June 2023): some comment A;

// Devyani Gupta (6th June 2023): some comment B;

// Dhairya Shah (6th June 2023): some comment C;

// Chinmay Shah (6th June 2023): some comment A
// Chinmay Shah (6th June 2023): some comment A;

// Devyani Gupta (6th June 2023): some comment B;

// Dhairya Shah (6th June 2023): some comment C;

// Chinmay Shah (6th June 2023): some comment A


// Chinmay Shah (6th June 2023): some comment A;

// Devyani Gupta (6th June 2023): some comment B;

// Dhairya Shah (6th June 2023): some comment C;

// Chinmay Shah (6th June 2023): some comment A

// ` ,
//     startup_status: 'awaiting_acceptance'
//   }
// }]

const CompanyDashboard = () => {
  const [tableHeadings, setTableHeadings] = useState(null)
  const [data, setData] = useState(null)

  const getCompany = useCallback(async () => {
    const data = await getCompanyData()
    // eslint-disable-next-line no-console
    console.log(data)
    const tableHeadings = [{
      id: 'name',
      label: 'Name',
      type: 'text',
      width: 190
    }, {
      id: 'website',
      label: 'Website',
      type: 'text',
      width: 150
    }, {
      id: 'last_interaction',
      label: 'Last Interaction',
      type: 'text',
      maxWidth: 300,
    }, {
      id: 'meetings',
      label: 'Meetings',
      type: 'expand',
      maxWidth: 300,
    }, {
      id: 'people_interacted',
      label: 'People Interacted',
      type: 'multi',
    }, {
      id: 'vc_pov',
      label: 'VC POV',
      type: 'expand',
      maxWidth: 300,
    }]
    setTableHeadings(tableHeadings)
    setData(data.map(raw => ({
      id: raw.domain,
      data: {
        name: raw.name,
        website: raw.domain,
        last_interaction: DateTime.fromISO(raw.last_interaction).toFormat('dd MMM yyyy'),
        meetings: raw.meetings,
        people_interacted: raw.people_interacted,
        vc_pov: raw.vc_comments,
      }
    })))
  }, [])

  useEffect(() => {
    getCompany()
  }, [])

  const renderCell = (header, row) => {
    const data = row.data[header.id]
    if (header.type === 'text') {
      return (
        <Box 
          maxH={'52px'}  
          overflow='hidden' 
          textOverflow='ellipsis' 
          color='#000000'
          fontSize={14}
          w={header.width || 'fit-content'}
          py={2}
          px={6}
          whiteSpace='nowrap'
        >
          <ReactLinkify componentDecorator={href => (
            <Box as='a' href={href} target='_blank' color='#000000' cursor='pointer' textDecoration='underline'>{href}</Box>
          )}>
            {data}
          </ReactLinkify>
        </Box>
      )
    }
    if (header.type === 'expand') {
      return (
        <Popover placement='left-start' matchWidth>
          <PopoverTrigger>
            <Box 
              maxH={'52px'}  
              color='#000000'
              fontSize={14}
              py={2}
              px={6}
              w={'fit-content'}
              maxWidth={header.maxWidth || 600}
              cursor='pointer'
            >
              <ReactLinkify componentDecorator={href => (
                <Box as='a' href={href} target='_blank' color='#000000' cursor='pointer' textDecoration='underline'>{href}</Box>
              )}>
                <Text
                  color='#000000'
                  fontSize={14}
                  // whiteSpace='pre-wrap'
                  whiteSpace='nowrap'
                  overflow='hidden' 
                  textOverflow='ellipsis' 
              
                >
                  {data}
                </Text>
              </ReactLinkify>
            </Box>
          </PopoverTrigger>

          <PopoverContent 
            left={'calc(100% + 8px)'}
            // w={'max-content'}
            width={348}
            py={2}
            px={6}
            _focusVisible={{
              outline: 'none'
            }}
            outline='none'
            maxH={'calc(75vh - 16px)'}
            overflow='scroll'
            border='none'
            boxShadow='0px 16px 10px rgba(2, 13, 49, 0.02), 0px 7px 7px rgba(2, 13, 49, 0.03), 0px 2px 4px rgba(2, 13, 49, 0.03), 0px 0px 0px rgba(2, 13, 49, 0.03)'
          >
            <ReactLinkify componentDecorator={href => (
              <Box as='a' href={href} target='_blank' color='#000000' cursor='pointer' textDecoration='underline'>{href}</Box>
            )}>
              <Text
                color='#000000'
                fontSize={14}
                whiteSpace='pre-line'
              >
                {data}
              </Text>
            </ReactLinkify>
          </PopoverContent>
        </Popover>
      )
    }
    if (header.type === 'multi') {
      // eslint-disable-next-line no-console
      // console.log('data', data)

      // const options = data.split(',').map(d => header.options.find(o => o.id === d)).filter(o => Boolean(o))
      // eslint-disable-next-line no-console
      // console.log('data', data.split(';'), options)

      const options = data.split(',').map((d, i) => ({
        id: d,
        label: d,
        backgroundColor: BG_COLORS[i%3],
        color: COLORS[i%3],
      }))

      return (
        <Popover placement='left-start' matchWidth>
          <PopoverTrigger>
            <Box 
              maxH={'52px'}  
              color='#000000'
              fontSize={14}
              py={2}
              px={6}
              w={'fit-content'}
              maxWidth={header.maxWidth || 600}
              cursor='pointer'
            >
              <Box display='flex' overflow='clip'>
                {options.map(option => (
                  <Box key={`${row.id}-${header.id}-${option.id}-col`} mr={2}>
                    <Box whiteSpace='nowrap' w='fit-content' borderRadius='32' px={2} flex={0} color={option.color} backgroundColor={option.backgroundColor}>{option.label}</Box>
                  </Box>
                ))}
              </Box>
            </Box>
          </PopoverTrigger>

          <PopoverContent 
            left={'calc(100% + 8px)'}
            // w={'max-content'}
            width={600}
            pb={2}
            px={6}
            _focusVisible={{
              outline: 'none'
            }}
            outline='none'
            maxH={'calc(75vh - 16px)'}
            overflow='scroll'
            border='none'
            boxShadow='0px 16px 10px rgba(2, 13, 49, 0.02), 0px 7px 7px rgba(2, 13, 49, 0.03), 0px 2px 4px rgba(2, 13, 49, 0.03), 0px 0px 0px rgba(2, 13, 49, 0.03)'
            display='flex'
          >
            {/* <Box display='flex' maxW='100%' overflowWrap='anywhere'> */}
            {/* {options.map(option => (
                <Box key={`${row.id}-${header.id}-${option.id}`} mr={2}>
                  <Box whiteSpace='nowrap' w='fit-content' borderRadius='32' px={2} flex={0} color={option.color} backgroundColor={option.backgroundColor}>{option.label}</Box>
                </Box>
              ))} */}
            {/* </Box> */}

            {options.map(option => (
              <Box key={`${row.id}-${header.id}-${option.id}-expanded`} mr={2} mt={2} whiteSpace='nowrap' w='fit-content' borderRadius='32' px={2} flex={0} color={option.color} backgroundColor={option.backgroundColor}>{option.label}</Box>
            ))}
          </PopoverContent>
        </Popover>
      )

      // return (
      //   <Box 
      //     maxH={'52px'}   
      //     h='100%' overflow='scroll' color='#000000'
      //     fontSize={14}
      //     py={2}
      //     px={6}
          
      //     className='noScrollbar'
      //   >
      //     <Box display='flex'>
      //       {options.map(option => (
      //         <Box key={`${row.id}-${header.id}-${option.id}`} mr={2}>
      //           <Box whiteSpace='nowrap' w='fit-content' borderRadius='32' px={2} flex={0} color={option.color} backgroundColor={option.backgroundColor}>{option.label}</Box>
      //         </Box>
      //       ))}
      //     </Box>
      //   </Box>
        
      // )
    }
    return
  }

  const renderRow = (row) => {
    return (
      <Tr key={row.id} maxH={'2ch'}>
        {tableHeadings.map((header) => (
          <Td
            backgroundColor='#FFFFFF'
            border='1px solid #CCCCCC'
            textTransform='none'
            key={`${row.id}-${header.id}`}
            p={0}
          >
            {renderCell(header, row)}
          </Td>
        ))}
      </Tr>
    )
  }

  return (
    <Container bg='brandBackground' maxW='full' px='131px' pt='48px' h='100vh'>
      <Box left='0' top='0' position='absolute'>
        <NavbarOpen />
      </Box>

      <Container
        maxW={9999999}
        // maxW='991px'
        mr={0}
        display='flex'
        flexDirection='column'
        h='full'
      >
        <Box overflow='scroll' py={4} minH='calc(100vh - 64px)'>
          {tableHeadings ? (
            <Table>
              <Thead>
                <Tr>
                  {tableHeadings.map(({label, id}) => (
                    <Th
                      backgroundColor='#F5F5F5'
                      border='1px solid #CCCCCC'
                      textTransform='none'
                      minWidth={0}
                      flex={0}
                      key={id}>{label}</Th>
                  ))}
                </Tr>
              </Thead>
              <Tbody>
                {data.map(row => renderRow(row))}
              </Tbody>
            </Table>
          ): <></>}
        </Box>
      </Container>
    </Container>
  )
}

export default CompanyDashboard